module.exports = __webpack_public_path__ + "officialStatic/img/n1.d99f539.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/news/n1.png
// module id = 33HB
// module chunks = 0